import * as React from 'react';

const CopySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M3 21h14V6H3v15zm-1 1h16V5H2v17z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M8 2v1h12v13h1V2zM9.4 10.5v2.9H6.5v1h2.9v2.9h1v-2.9h2.9v-1h-2.9v-2.9z"
        />
    </svg>
);

CopySvg.displayName = 'CopySvg';
export default CopySvg;
